import axios, { AxiosResponse } from "axios";
import { storage } from "../../lib/storage";
export const API_URL = `${process.env.NEXT_PUBLIC_BACKEND_URL}`;

//Dummy

enum REST_METHODS {
  GET = "get",
  POST = "post",
  DELETE = "delete",
  PATCH = "patch",
}

axios.defaults.validateStatus = function () {
  return true;
};

axios.interceptors.response.use(function (response) {
  if (response.status === 401) {
    storage.clearLoginDetails();
    // Trigger auth change event to update useAuth hook
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('authChange'));
    }
    const currentUrl = window.location.href;
    if (window.location.href.includes("/userProfile/profile")) {
      const newUrl = currentUrl.replace("/userProfile/profile", "");
      window.location.href = newUrl;
    }
  }

  return response;
});

const apiCaller = async (
  {
    method,
    params,
    url,
    data,
    headers,

  }: {
    method: REST_METHODS;
    params?: Record<string, unknown>;
    url: string;
    data?: Record<string, unknown> | FormData;
    headers?: Record<string, unknown>;
  } = {
    method: REST_METHODS.GET,
    params: {},
    data: {},
    headers: {},
    url: "",
  }
) => {
  const userToken = storage.getLoginDetails().token;
  if (userToken) {
    headers = { ...headers, Authorization: `Bearer ${userToken}` };
  }
  if (method === REST_METHODS.GET) {
    //@ts-expect-error - axios types mismatch with our custom params
    return axios.get(url, { params, headers });
  }

  //@ts-expect-error - axios types mismatch with our custom params
  return axios({
    method: method,
    url,
    data,
    headers,
    params,
  });
};

const API = {
  validators: {
    checkSuccessCode: (response: AxiosResponse): boolean => {
      return Math.floor(response.status / 100) === 2;
    },
    matchStatusCode: (response: AxiosResponse, statusCode: number): boolean => {
      return response.status === statusCode ? true : false;
    },
  },
  client: {
    CreateLead: ({
      phone,
      name,
      email,
      message,
      city,
      noOfBikes,
    }: {
      phone: string;
      name: string;
      email: string;
      message: string;
      city: string;
      noOfBikes: number;
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        url: `${API_URL}/lead/`,
        data: { phone, name, email, message, city, noOfBikes },
      });
    },
  },
  user: {
    SendOtp: ({ phoneNo }: { phoneNo: string }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        url: `${API_URL}/auth/user/login`,
        data: { mobile: phoneNo },
      });
    },
    SubmitOtp: ({ phoneNo, otp }: { phoneNo: string; otp: string }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        url: `${API_URL}/auth/user/verify`,
        data: { mobile: phoneNo, otp: otp },
      });
    },
    UpdateUserDetails: ({
      id,
      name,
      email,
    }: {
      id: string;
      name: string;
      email: string;
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        url: `${API_URL}/auth/user/update`,
        data: { id: id, name: name, email: email },
      });
    },
    GetCities: () => {
      return apiCaller({
        method: REST_METHODS.GET,
        url: `${API_URL}/city/list`,
      });
    },
    SelectedCityAvailableBikes: ({
      city,
      pickupDate,
      dropoffDate,
      transmissionType,
      stations,
      brandName,
    }: {
      city: string;
      pickupDate: string;
      dropoffDate: string;
      transmissionType?: string;
      stations?: string[];
      brandName?: string[];
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        data: {
          city: city,
          pickupDate: pickupDate,
          dropoffDate: dropoffDate,
          transmissionType: transmissionType,
          stations: stations,
          brandName: brandName,
        },
        url: `${API_URL}/bike/available/all`,
      });
    },

    CheckoutPage: ({
      bikeId,
      from,
      to,
    }: {
      bikeId: string;
      from: Date;
      to: Date;
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        data: {
          bikeId: bikeId,
          from: from,
          to: to,
        },
        url: `${API_URL}/bike/checkout-availability`,
      });
    },
    CreateOrder: ({
      userId,
      stationId,
      bikeId,
      accessories,
      deliveryInfo,
      isPartial,
      from,
      to,
    }: {
      userId: string;
      stationId: string;
      bikeId: string;
      accessories?: { id: string; qty: number }[];
      deliveryInfo?: Record<string, unknown>;
      isPartial?: boolean;
      from: string | Date;
      to: string | Date;
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        data: {
          userId,
          stationId,
          bikeId,
          accessories,
          deliveryInfo,
          isPartial,
          from,
          to,
        },
        url: `${API_URL}/booking/order`,
      });
    },
    RazorpayConfirmation: ({
      order_id,
      payment_id,
      signature,
    }: {
      order_id: string
      payment_id: string
      signature: string
    }) => {
      return apiCaller({
        method: REST_METHODS.POST,
        data: {
          order_id,
          payment_id,
          signature,
        },
        url: `${API_URL}/booking/payment/webhook/razorpay-confirmation`,
      });
    },
    
    PaymentSuccessfullCheck: ({ id }: { id: string }) => {
      return apiCaller({
        method: REST_METHODS.GET,
        url: `${API_URL}/booking/order/status/${id}`,
      });
    },
    ProfileDetails: () => {
      return apiCaller({
        method: REST_METHODS.POST,
        url: `${API_URL}/auth/user/details`,
        data: {},
      });
    },
    BookingHistory: () => {
      return apiCaller({
        method: REST_METHODS.GET,
        url: `${API_URL}/booking/bookings/user`,
      });
    },
  },
};

export default API;
